export default {
    home: '/',
    about: '/about/',
    gallery: '/gallery/',
    gallery_custom: '/gallery/custom-homes/',
    gallery_remodels: '/gallery/remodels/',
    gallery_additions: '/gallery/additions/',
    gallery_garages: '/gallery/garages/',
    testimonials: '/testimonials/',
    vendors: '/vendors/',
    resources: '/resources/',
    faq: '/resources/faq/',
    building_101: '/resources/building-101/',
    what_to_expect: '/resources/what-to-expect/',
    our_process: '/resources/our-process/',
}
